import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import './Parametros.css';

function Parametros() {
  const [empresa, setEmpresa] = useState('');
  const [identificacion, setIdentificacion] = useState('');
  const [impuesto, setImpuesto] = useState(13);
  const [numCotizacion, setNumCotizacion] = useState(0);
  const [numeroRecibo, setNumeroRecibo] = useState(0);
  const [estado, setEstado] = useState('');
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const cargarParametros = async () => {
      try {
        const docRef = doc(db, 'Parametros', 'configuracion');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setEmpresa(data.empresa || '');
          setIdentificacion(data.identificacion || '');
          setImpuesto(data.impuesto !== undefined ? data.impuesto : 13);
          setNumCotizacion(data.numCotizacion !== undefined ? data.numCotizacion : 0);
          setNumeroRecibo(data.numeroRecibo !== undefined ? data.numeroRecibo : 0);
        }
      } catch (error) {
        console.error('Error al cargar parámetros:', error);
        setEstado('⚠️ Error al cargar los parámetros.');
      } finally {
        setCargando(false);
      }
    };
    cargarParametros();
  }, []);

  const guardarParametros = async () => {
    setEstado('Guardando...');
    try {
      await setDoc(doc(db, 'Parametros', 'configuracion'), {
        empresa: empresa.trim(),
        identificacion: identificacion.trim(),
        impuesto: Number(impuesto),
        numCotizacion: Number(numCotizacion),
        numeroRecibo: Number(numeroRecibo)
      });
      setEstado('✅ Parámetros guardados correctamente.');
      
      setTimeout(() => {
        setEstado('');
      }, 3000);
    } catch (error) {
      console.error('Error al guardar parámetros:', error);
      setEstado(`⚠️ Error al guardar los parámetros: ${error.message}`);
    }
  };

  if (cargando) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Cargando parámetros...</p>
      </div>
    );
  }

  return (
    <div className="parametros-container">
      <div className="parametros-header">
        <h2>⚙️ Parámetros del Sistema</h2>
      </div>
      
      <div className="parametros-card">
        <div className="form-section">
          <h3>Información de la Empresa</h3>
          {/* Fila para Nombre de Empresa e Identificación */}
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="nombre-empresa">Nombre de la Empresa:</label>
              <input
                id="nombre-empresa"
                type="text"
                value={empresa}
                onChange={(e) => setEmpresa(e.target.value)}
                placeholder="Ej: Soluciones Inmediatas de San José"
              />
            </div>
            <div className="form-group identificacion-group">
              <label htmlFor="identificacion-empresa">Identificación:</label>
              <input
                id="identificacion-empresa"
                type="text"
                value={identificacion}
                onChange={(e) => setIdentificacion(e.target.value)}
                placeholder="Ej: 3-101-000000"
              />
            </div>
          </div>
          {/* Fila para Impuesto y Consecutivo con etiquetas en línea */}
          <div className="form-inline-group">
            <label htmlFor="impuesto">Impuesto (%):</label>
            <input
              id="impuesto"
              type="number"
              value={impuesto}
              onChange={(e) => setImpuesto(e.target.value)}
              className="inline-input"
            />
            <span className="inline-separator">/</span>
            <label htmlFor="numCotizacion">Cotizaciones:</label>
            <input
              id="numCotizacion"
              type="number"
              value={numCotizacion}
              onChange={(e) => setNumCotizacion(e.target.value)}
              className="inline-input"
            />
             <span className="inline-separator">/</span>
            <label htmlFor="numeroRecibo">Recibos:</label>
            <input
              id="numeroRecibo"
              type="number"
              value={numeroRecibo}
              onChange={(e) => setNumeroRecibo(e.target.value)}
              className="inline-input"
            />
          </div>
        </div>
        
        <div className="parametros-footer">
          <button onClick={guardarParametros} className="btn btn-primary">
            Guardar Parámetros
          </button>
        </div>
        
        {estado && (
          <div className={`status-message ${estado.includes('Error') ? 'error' : 'success'}`}>
            <p>{estado}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Parametros;